import React, { useContext } from 'react';
import {
    Box, Avatar, Typography, Button, CircularProgress,
} from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { FetchPolicy } from 'utils/enum/Core';
import avatarUser from 'assets/user/userDefault.jpg';
import useLogOut from 'components/hook/core/useLogOut';
import UserContext from 'components/context/UserContext';
import TimeClockQuery from 'services/graphQL/query/TimeClockQuery';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import TimeClockIPAccessDenied from 'components/modules/timeclock/TimeClockIPAccessDenied';
import TimeClockHome from 'components/modules/timeclock/TimeClockHome';
import { useTimeClockLayoutStyles } from 'styles/modules/timeclock/TimeClockStyles';
import usePublicIp from '../hook/core/usePublicIp';

const TimeClockLayout = () => {
    const classes = useTimeClockLayoutStyles();
    const { logOut, executingLogOut } = useLogOut();
    const { userInformation } = useContext(UserContext);
    const { ip, isIpResolved } = usePublicIp();

    const userName = [userInformation?.firstName, userInformation?.lastName].filter(Boolean).join(' ').trim() || 'No User';
    const {
        data: isIPAllowedData, loading: isIPAllowedLoading,
    } = useQuery(TimeClockQuery.IS_IP_ALLOWED_TO_TIME_CLOCK, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: FetchPolicy.NETWORK_ONLY,
        variables: {
            ip,
        },
        skip: !isIpResolved || !ip,
    });

    const isIpAllowed = isIPAllowedData?.isIPAllowedToTimeClock || false;
    const isLoading = !isIpResolved || isIPAllowedLoading;

    return (
        <Box className={classes.layoutRoot}>
            <Box component="header" className={classes.layoutHeader}>
                <Box className={classes.layoutUserInfo}>
                    <Avatar
                        src={userInformation?.userPicture || avatarUser}
                        alt={userName}
                        className={classes.layoutAvatar}
                    />
                    <Box>
                        <Typography variant="body2" className={classes.layoutUserName}>
                            {userName}
                        </Typography>
                        <Typography variant="caption" className={classes.layoutUserCaption}>
                            {userInformation?.company?.companyName || 'No Company Name'}
                        </Typography>
                    </Box>
                </Box>
                <Box className={classes.layoutUserInfo}>
                    <Typography variant="h6" className={classes.layoutBrand}>
                        TimeClock
                    </Typography>
                    <Button
                        variant="text"
                        color="inherit"
                        className={classes.layoutLogoutButton}
                        aria-label="Logout"
                        onClick={logOut}
                        disabled={executingLogOut}
                    >
                        <PowerSettingsNewIcon />
                    </Button>
                </Box>
            </Box>
            <Box className={classes.layoutMain}>
                {isLoading && (
                    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                        <CircularProgress />
                    </Box>
                )}
                {(!isLoading && !isIpAllowed) && (
                    <TimeClockIPAccessDenied />
                )}
                {(!isLoading && isIpAllowed) && (
                    <TimeClockHome />
                )}
            </Box>
        </Box>
    );
};

export default TimeClockLayout;
